import React from "react";
import { Typography } from "antd";

/** Standard antd-styled validation error shown under a field input. Renders nothing when empty. */
const FieldError = ({ message }: { message?: string }) =>
    message ? (
        <div style={{ marginTop: 2 }}>
            <Typography.Text type="danger">{message}</Typography.Text>
        </div>
    ) : null;

export default FieldError;
